import { render, staticRenderFns } from "./ContactNote.vue?vue&type=template&id=a5d51ce6&scoped=true&"
import script from "./ContactNote.vue?vue&type=script&lang=js&"
export * from "./ContactNote.vue?vue&type=script&lang=js&"
import style0 from "./ContactNote.vue?vue&type=style&index=0&id=a5d51ce6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d51ce6",
  null
  
)

export default component.exports